/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Picker_YouInputs */

const en_picker_you = /** @type {(inputs: Picker_YouInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (you)`)
};

const de_picker_you = /** @type {(inputs: Picker_YouInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} (du)`)
};

/**
* | output |
* | --- |
* | "{name} (you)" |
*
* @param {Picker_YouInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const picker_you = /** @type {((inputs: Picker_YouInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Picker_YouInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_picker_you(inputs)
	return en_picker_you(inputs)
});